import React from "react"
import PriceTable from "../../widgets/PriceTable"
import Faqs from "../../widgets/Faqs"
import Seo from '../../html/Seo'

function Pricing () {
    return(
        <>
            <Seo title={'Try Free Pole Dance Lessons Online for 14 Days'}
                 description={'Want to nail that inversion? Looking to get deeper in your bend? Try free pole dance lessons online for 14 days. We offer lessons in pole, floor, and aerial.'}
            />
            <PriceTable />
            <Faqs/>
        </>
    )
}
export default Pricing
